import { ComponentStyleConfig } from '@chakra-ui/react'
import { getColor } from '@chakra-ui/theme-tools'

import { colors } from '../foundations/colors'

export const Tabs: ComponentStyleConfig = {
  defaultProps: {
    variant: 'gradient',
  },
  variants: {
    gradient: {
      tab: {
        _active: {
          background: 'neutral.30',
          borderBottomColor: 'deepPurple',
          color: 'deepPurple',
        },
        _disabled: {
          background: 'unset',
          borderBottomColor: 'neutral.30',
          boxShadow: 'unset',
          color: 'neutral.30',
          pointerEvents: 'none',
        },
        _hover: {
          background: 'neutral.10',
          borderBottomColor: 'deepPurple',
          color: 'deepPurple',
        },
        _selected: {
          _active: {
            background: 'blue.30',
            borderBottom: '3px solid',
            borderBottomColor: 'blue.60',
            color: 'deepPurple',
          },
          _hover: {
            background: 'blue.10',
            borderBottomColor: 'blue.50',
            color: 'deepPurple',
          },
          background: 'unset',
          borderBottom: '3px solid',
          borderImageSlice: 1,
          borderImageSource: `linear-gradient(90deg, ${getColor(
            { colors },
            'violet.50',
          )}, ${getColor({ colors }, 'blue.50')})`,
          boxShadow: 'unset',
          color: 'deepPurple',
        },
        background: 'unset',
        border: 'unset',
        borderBottom: '1px solid',
        borderBottomColor: 'neutral.30',
        boxShadow: 'unset',
        color: 'neutral.70',
        fontWeight: 400,
      },
    },
  },
}
